import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=1852c052&scoped=true&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=1852c052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852c052",
  null
  
)

export default component.exports